// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__3Pmtu","header":"MergedInvoice_header__1qPwZ"};